export const CommonPublishedEventsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Ricerca Eventi Pubblicati',
    path: '/sistema/eventmanager/ricerca-eventi-pubblicati',
  },
];
